/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  nazevCs: {
    id: "b2b.zdroj-editace-form.field.nazevCs.label",
    defaultMessage: "Name CS"
  },
  nazevEn: {
    id: "b2b.zdroj-editace-form.field.nazevEn.label",
    defaultMessage: "Name EN"
  },
  popisCs: {
    id: "b2b.zdroj-editace-form.field.popisCs.label",
    defaultMessage: "Description CS"
  },
  popisEn: {
    id: "b2b.zdroj-editace-form.field.popisEn.label",
    defaultMessage: "Description EN"
  },
  exkluzivita: {
    id: "b2b.zdroj-editace-form.field.exkluzivita.label",
    defaultMessage: "Exclusive"
  },
  maxPocetPozadavku: {
    id: "b2b.zdroj-editace-form.field.maxPocetPozadavku.label",
    defaultMessage: "Maximum number of requests"
  },
  pozadavekSmena: {
    id: "b2b.zdroj-editace-form.field.pozadavekSmena.label",
    defaultMessage: "Shift required"
  },
  platnostOd: {
    id: "b2b.zdroj-editace-form.field.platnostOd.label",
    defaultMessage: "Valid from"
  },
  titleNew: {
    id: "b2b.zdroj-editace-widget.titleNew",
    defaultMessage: "New resource"
  },
  saveDialogTitle: {
    id: "b2b.zdroj-editace-form.save-dialog.title",
    defaultMessage: "Save resource"
  },
  deleteDialogTitle: {
    id: "b2b.zdroj-editace-form.delete-dialog.title",
    defaultMessage: "Delete resource"
  },
  buttonDelete: {
    id: "b2b.zdroj-editace-form.button.delete",
    defaultMessage: "Delete"
  },
  buttonSubmit: {
    id: "b2b.zdroj-editace-form.button.submit",
    defaultMessage: "Save"
  },
  buttonCancel: {
    id: "b2b.zdroj-editace-form.button.cancel",
    defaultMessage: "Cancel"
  }
});

export default () => useMessages(MESSAGES);
